import { VStack } from '@chakra-ui/react'
import React from 'react'
import nextId from 'react-id-generator'

import { Select } from '@/components/Form'
import SLAOptions from '@/features/SLAs/constants/SLAOptions'

const SLAQuestionaire = ({ name, active, canEdit }) => {
  return (
    <VStack display={active ? '' : 'none'}>
      {Object.keys(SLAOptions).map((SLASection, sectionIndex) => (
        <Select
          key={nextId('SLAOptions_')}
          label={`${sectionIndex + 1}. ${SLAOptions[SLASection].title}`}
          name={`${name}.${SLASection}`}
          options={SLAOptions[SLASection].options}
          isMulti
          disabled={!canEdit}
        />
      ))}
    </VStack>
  )
}

export default SLAQuestionaire
